import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

import styles from './style';
import Box from '../../../../components/atomic/Box';
import PublicSharingLabel from '../../../../components/PublicSharingLabel';
import { sGetActiveProperty } from '../../../../store/reducers/properties';
import PublicPropertyAddress from '../../../../components/PublicPropertyAddress';

const MobileHeader = ({ property, headerAdditionalContent, classes }) => (
  <Box>
    <Box
      display="flex"
      flexDirection="row"
      className={classes.container}
      justifyContent="space-between"
    >
      <PublicPropertyAddress property={property} />
      &nbsp;
      <PublicSharingLabel labelProps={{ className: classes.publicLabel }} />
    </Box>

    {headerAdditionalContent}
  </Box>
);

const mapStateToProps = (state) => ({
  property: sGetActiveProperty(state),
});

export default connect(mapStateToProps)(withStyles(styles)(MobileHeader));
